import React from 'react';
import Snackbar from 'material-ui/Snackbar';
import {
    Row, Col
} from 'reactstrap';
import axios from 'axios';
import urlBase from '../../../url-base';
import InputMask from 'react-input-mask';

import MenuItem from "material-ui/MenuItem";
//import TextField from "material-ui/TextField";
import SelectField from "material-ui/SelectField";
import Dialog from 'material-ui/Dialog';
import { FaStepBackward } from "react-icons/fa";
import {Colors, Styles} from '../../../../src/styles/theme';

//import * as yup from 'yup';

import {browserHistory } from 'react-router';

const availWidth = window.screen.availWidth;

class Inclusao extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            cpfInput: '',
            dadosAssociado: null,   
            contratoSelecionado: null,              
            novoDep: {
                    cpf: '',
                    nomeDependente: '',
                    dataNascimento: '',
                    sexo: '',
                    nomeMae: '',
                    parentesco: '',
                    celular: '',
                    estadoCivil: '',
                    cartaoSus: ''
                },
            carregandoDados: false,   
            dependentesParaIncluir: [],  
            cpfValidado: '',
            mensagemErro: '',
            snackbar: {
                open: false,
                msg: ''
            },
            confirmacaoAberta: false, 
            isSending: false,
            sucessoAberto: false,   
            errosCampos: {}

        };
        this.handleSearch = this.handleSearch.bind(this);
        this.selecionarContrato = this.selecionarContrato.bind(this);
        this.verificarEApurarCPF = this.verificarEApurarCPF.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this);

        this.styles = {
                              
            h1: {
                fontSize: availWidth < 500 ? 12 : 16,
                fontWeight: 100,
                paddingRight: 12,
                marginTop: 17,
                fontFamily: 'RubikRegular',
                color: "#757575",
                paddingLeft: 15,
            },
            hr: {
                height: '1px',
                backgroundColor: '#d1d1d1',
                textAlign: 'center',
                width: '100%',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: '40px',
            },
            hh1: {
                fontSize: availWidth < 500 ? 12 : 16,
                fontWeight: 100,
                paddingRight: 12,
                marginTop: 2,
                fontFamily: 'RubikRegular',
                color: "#757575",
                paddingLeft: 15,
            },                                                 
            p: {
                marginTop: 5,
                paddingTop: 9,
                fontSize: 20,
                fontWeight: 300,
                width: 50,
                height: 50,
                marginRight: 20,
                backgroundColor: "#f9f9f9",
                borderRadius: "100%",
                textAlign: "center",
                fontFamily: 'RubikMedium',
                color: "#757575",
            },
            tituloPagina2: {
                fontSize: availWidth < 500 ? 18 : 23,
                fontFamily: 'RubikMedium',
                width: '100%',
                color: "#757575",
                marginLeft: 'auto',
                marginRight: 'auto',
                paddingTop: 0,
                paddingBottom: 40,
                textAlign: "center",
            },          
            closeBtn: {
                float: 'right',
                width: 25,
                cursor: 'pointer',
                position: 'relative',
                bottom: 15,
                left: 5
            },
            modal: {
                width: '100%',
                maxWidth: 'none'
            }
        };    
        /*
        const dependenteSchema = yup.object().shape({
            nomeDependente: yup.string().required("O nome é obrigatório"),
            dataNascimento: yup.string().required("A data de nascimento é obrigatória"),
            nomeMae: yup.string().required("O nome da mãe é obrigatório"),
            sexo: yup.string().required("O sexo é obrigatório"),
            parentesco: yup.string().required("O parentesco é obrigatório"),
            estadoCivil: yup.string().required("O estado civil é obrigatório"),
            cpf: yup.string().required("O CPF é obrigatório"),
            // cartaoSus não tem .required()
        });  
        */           
    }

    componentDidMount() {
      
       // this.obterPlanosPJ();           
        if (localStorage.getItem('dental_y') == 'SALESMAN') {
            let idUser = localStorage.getItem('dental_u');
            axios.get(urlBase.loopBack + 'Salesmans?filter={"where":{"userId":"' + idUser + '"},"include":["user",{"broker":"user"}]}')
                .then((result) => {

                    if (result.data.length == 0) {
                        alert('Vendedor não encontrado');
                    } else {

                        this.setState({
                        brokerId: result.data[0].brokerId,
                        salesmanCodeS4: result.data[0].codeS4
                        });

                    }
                })
                .catch(function () {
                    alert('Problema encontrado so tentar selecionar os dados do vendedor, entre em contato com o suporte!');
                    this.props.onClickFn();
                }.bind(this));
        }
    }
    
    snackbarRequestClose() {
        let state = this.state;
        state.snackbar.open = false;
        state.snackbar.msg = '';
        this.setState(state);
    }

    showBox() {
        let state = this.state;
        let type = localStorage.getItem('dental_y');

        if (type == 'SALESMAN' || type == 'BROKER' || type == 'BACKOFFICE') {
            state.showLeads = false;
        }
        else if (type == 'REGISTER') {
            state.showLeads = false;
            state.showAwaitingSolution = false;
            state.showPJawaitingPayment = false;
            state.showPJonActivation = false;
            state.showPJactivated = false;
        }
        else if (type == 'AFTER SALES') {
            state.showLeads = false;
            state.showAwaitingSolution = false;
            state.showWaitingConfirmation = false;
            state.showPJawaitingPayment = false;
            state.showPJonActivation = false;
            state.showPJactivated = false;
        }
        else if (type == 'ADMIN') {
            state.showLeads = false;
            state.showAwaitingSolution = false;
            state.showPanelPJ = false;
            state.showPJonActivation = false;
            state.showPJactivated = false;
        }
        else if (type == 'PJCADASTRO') {
            state.showLeads = false;
            state.showAwaitingSolution = false;
            state.showPJawaitingPayment = false;
            state.showPJawaitingPayment = false;
            state.showPanelPF = false;
        }
        else {
            state.showLeads = false;
            state.showAwaitingSolution = false;
            state.showWaitingConfirmation = false;
            state.showAwaitingAfterSale = false;
            state.showImplantedContracts = false;
            state.showCanceledContracts = false;
            state.showMaterials = false;
            state.showNews = false;
            state.showPending = false;
            state.showPanelPJ = false;
            state.showPJonActivation = false;
            state.showPJactivated = false;
        }

        this.setState(state);
    }

    goBack() {
        window.history.back();
    }

                                   
   
   
/* NOVO */
    validarCPF(cpf) {
        cpf = cpf.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos
        if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false;

        let soma = 0, resto;
        for (let i = 1; i <= 9; i++) soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
        resto = (soma * 10) % 11;
        if ((resto === 10) || (resto === 11)) resto = 0;
        if (resto !== parseInt(cpf.substring(9, 10))) return false;

        soma = 0;
        for (let i = 1; i <= 10; i++) soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
        resto = (soma * 10) % 11;
        if ((resto === 10) || (resto === 11)) resto = 0;
        if (resto !== parseInt(cpf.substring(10, 11))) return false;

        return true;
    }
    handleSearch() {
        const cpf = this.state.cpfInput.replace(/[^\d]+/g, '');

        var dataPost = {
            cpf: cpf
        };

        if (!this.validarCPF(cpf)) {
            alert("CPF Inválido!");
            return;
        }

        const url = urlBase.loopBack + 'APIS4s/Associados';
        axios.post(url, dataPost)  
            .then(function(response) {
                if (response.data && response.data.length > 0) {
                    
                    // FILTRO: Retorna apenas contratos que tenham algum dependente ATIVO
                    var contratosAtivos = response.data.filter(function(contrato) {
                        return contrato.dependentes && contrato.dependentes.some(function(dependente) {
                            return dependente.nomeSituacao === "ATIVO";
                        });
                    });

                    if (contratosAtivos.length > 0) {
                        this.setState({ 
                            listaContratos: contratosAtivos,
                            dadosAssociado: contratosAtivos[0],
                            contratoSelecionado: null // GARANTE QUE VOLTE PARA A LISTA NA NOVA BUSCA
                        });
                    } else {
                        alert("Contrato com pendência para este CPF! Entre em contado com a dental center através do número (83) 3041-4646.");
                        this.setState({ 
                            listaContratos: [], 
                            dadosAssociado: null, 
                            contratoSelecionado: null,
                            errosCampos: {},           
                            mensagemErro: null,

                        });
                    }

                } else {
                    alert("Nenhum registro encontrado.");
                    this.setState({ 
                        listaContratos: [], 
                        dadosAssociado: null, 
                        contratoSelecionado: null 
                    });
                }
            }.bind(this))
            .catch(function(error) {
                console.error(error);
                alert("Erro na API.");
            });
    } 
    /**
     * Verificar CPF
     * @returns 
     */
    verificarEApurarCPF() {
    var self = this;

    // 1. Limpeza e validações iniciais
    var cpfLimpoParaBusca = (this.state.novoDep.cpf || "").replace(/[^\d]+/g, '');

    this.setState({
        errosCampos: {},
        mensagemErro: null,
        carregandoDados: false
    });

    //self.setState({ mensagemErro: '', carregandoDados: false });

    if (cpfLimpoParaBusca.length !== 11) {
        self.setState({ mensagemErro: "CPF incompleto ou inválido!" });
        return;
    }

    if (!this.validarCPF(cpfLimpoParaBusca)) {
        self.setState({ mensagemErro: "CPF Inválido!" });
        return;
    }

    // 2. Verificação em dependentes ATIVOS do contrato
    var jaEstaAtivo = this.state.contratoSelecionado.dependentes.some(function(d) {
        var cpfAtivo = (d.numeroCpfDependente || "").replace(/[^\d]+/g, '');
        return cpfAtivo === cpfLimpoParaBusca && d.nomeSituacao === "ATIVO";
    });

    if (jaEstaAtivo) {
        self.setState({
            mensagemErro: "Este CPF já é um dependente ATIVO neste contrato."
        });
        return;
    }

    // 3. Verificação de duplicidade na LISTA TEMPORÁRIA
    var jaEstaNaLista = this.state.dependentesParaIncluir.some(function(dep) {
        var cpfNaLista = (dep.cpf || "").replace(/[^\d]+/g, '');
        // ✅ ignora CPF vazio (menores de 10 anos)
        return cpfNaLista && cpfNaLista === cpfLimpoParaBusca;
    });

    if (jaEstaNaLista) {
        self.setState({
            mensagemErro: "Este CPF já foi adicionado à lista de inclusão."
        });
        return;
    }

    // 4. Chamada da API
    self.setState({ carregandoDados: true });

    var url = urlBase.loopBack + 'APIS4s/BuscaDadosPorCPF?cpf=' + cpfLimpoParaBusca;

    axios.get(url)
        .then(function(response) {

            var cpfDaPesquisa = cpfLimpoParaBusca;

            // ✅ CPF ENCONTRADO NA BASE
            if (response.data && response.data.dadosCadastrais) {
                var cad = response.data.dadosCadastrais;

                var novoDepAtualizado = Object.assign({}, self.state.novoDep, {
                    cpf: self.state.novoDep.cpf, // ✅ preserva CPF
                    nomeDependente: cad.nome ? cad.nome.toUpperCase() : '',
                    dataNascimento: cad.dataNascimento || '',
                    sexo: (cad.sexo === "Masculino" || cad.sexo === "1") ? "1" : "0",
                    nomeMae: cad.maeNome ? cad.maeNome.toUpperCase() : '',
                    isReadOnly: true
                });

                self.setState({
                    novoDep: novoDepAtualizado,
                    cpfValidado: cpfDaPesquisa,
                    carregandoDados: false,
                    modalAberto: true
                });

            // ❗ CPF NÃO ENCONTRADO NA BASE (cadastro manual)
            } else {
                var novoDepManual = Object.assign({}, self.state.novoDep, {
                    cpf: self.state.novoDep.cpf, // ✅ NÃO APAGA CPF
                    nomeDependente: '',
                    dataNascimento: '',
                    sexo: '',
                    nomeMae: '',
                    isReadOnly: false
                });

                self.setState({
                    novoDep: novoDepManual,
                    cpfValidado: cpfDaPesquisa,
                    carregandoDados: false,
                    modalAberto: true,
                    mensagemErro: "Erro ao consultar base de dados. O preenchimento será manual."
                });
            }
        })
        .catch(function(err) {
            console.log(err);
            // ❗ ERRO NA API → cadastro manual, sem limpar CPF
            var erroDep = Object.assign({}, self.state.novoDep, {
                cpf: self.state.novoDep.cpf, // ✅ mantém CPF
                isReadOnly: false
            });

            self.setState({
                carregandoDados: false,
                mensagemErro: "Erro ao consultar base de dados. O preenchimento será manual.",
                novoDep: erroDep,
                cpfValidado: cpfLimpoParaBusca,
                modalAberto: true
            });
        });
    }

    /**
     * Adicionar dependente
     * @returns 
     */
    adicionarDependenteAFila() {
        // 1. Extraímos as variáveis necessárias do state
        const { novoDep, dependentesParaIncluir, cpfValidado } = this.state;

        // 2. Criamos a variável cpfNoCampo limpando a máscara do que está no input agora
        const cpfNoCampo = (novoDep.cpf || "").replace(/[^\d]+/g, '');

        /* RETIRAR ESSA VALIDAÇÃO PQ CPF É OBRIGATÓRIO PARA TODOS
        // ✅ calcula idade a partir da data informada
        const idade = this.calcularIdade(novoDep.dataNascimento);

        
        if (idade > 10 && cpfNoCampo.length !== 11) {
            this.setState({
                mensagemErro: "CPF é obrigatório para dependentes com mais de 10 anos."
            });
            return;
        }
        */

        // TRAVA DE SEGURANÇA: Comparamos o que está no campo com o que foi validado pelo Axios
        if (cpfNoCampo !== cpfValidado) {
            this.setState({ mensagemErro: "Erro: O CPF foi alterado após a pesquisa. Por favor, feche o modal e pesquise novamente o novo CPF." });
            return; // Bloqueia a inclusão
        }

        // 3. Verificamos se já existe na lista temporária (usando o CPF limpo)
        const jaExisteNaLista = dependentesParaIncluir.some(function(dep) {
            const cpfListaLimpo = (dep.cpf || "").replace(/[^\d]+/g, '');

            // ✅ ignora comparação se algum dos dois CPFs estiver vazio
            if (!cpfListaLimpo || !cpfNoCampo) {
                return false;
            }

            return cpfListaLimpo === cpfNoCampo;
        });

        if (jaExisteNaLista) {
            this.setState({ mensagemErro: "Erro: Este CPF já consta na lista de inclusão." });
            return;
        }

        // 4. Validação de campos obrigatórios

        if (!this.validarCamposObrigatorios()) {
            this.setState({ mensagemErro: "Preencha os campos obrigatórios destacados.." });
            return;
        }
        /*
        if (
            !novoDep.nomeDependente ||
            !novoDep.dataNascimento ||
            !novoDep.sexo ||
            !novoDep.parentesco ||
            !novoDep.estadoCivil ||
            !novoDep.cpf
        ) {
            this.setState({
                mensagemErro: "Por favor, preencha todos os campos obrigatórios."
            });
            return;
        }
        */

        // 5. Calcula o novo valor unitário
        const novoValorUnitario = this.calcularPrecoPorVidas(dependentesParaIncluir.length + 1);

        // 6. Prepara o novo dependente (salvando o CPF limpo)
        const dependenteComPrecoNovo = Object.assign({}, novoDep, { 
            cpf: cpfNoCampo, 
            valorPlano: novoValorUnitario 
        });

        // 7. Atualiza todos da fila
        const listaAtualizada = dependentesParaIncluir.map(function(dep) {
            return Object.assign({}, dep, { valorPlano: novoValorUnitario });
        });

        listaAtualizada.push(dependenteComPrecoNovo);

        // 8. Atualiza o estado e limpa TUDO (inclusive o cpfValidado)
        this.setState({
            dependentesParaIncluir: listaAtualizada,
            modalAberto: false,
            cpfValidado: '', // Limpa para a próxima pesquisa
            novoDep: { 
                cpf: '', 
                nomeDependente: '', 
                dataNascimento: '', 
                sexo: '', 
                nomeMae: '', 
                parentesco: '', 
                celular: '', 
                estadoCivil: '', 
                cartaoSus: '',
                isReadOnly: false 
            }
        }, function() {
            console.log("Dependente adicionado. Nova lista:", this.state.dependentesParaIncluir);
        });
    }  
    

    /**
     * Busca valor do Plano
     * @param {*} codigoS4 
     */
    buscarDadosDoPlano(id) {
        var self = this;
        // Usando o filtro que você mencionou anteriormente
        let url = `${urlBase.loopBack}Plans/findOne?filter={"where":{"codeS4":"${id}"}}`;
        
        axios.get(url).then(function(res) {
            if (res.data) {
                console.log("Plano carregado com sucesso:", res.data);
                self.setState({ dadosPlanoLogado: res.data });
            }
        }).catch(function(err) {
            console.error("Erro ao buscar plano:", err);
        });
    }
    /**
     * Calcula valor do plano
     * @returns 
     */
    calcularPrecoPorVidas(quantidadeNovos) {
        const { dadosPlanoLogado, contratoSelecionado } = this.state;
        if (!dadosPlanoLogado) return 0;

        // 1. Contamos apenas os dependentes ATIVOS que NÃO sejam o titular
        // (Ajuste o termo "TITULAR" se no seu banco for "Titular" ou outro nome)
        const dependentesReaisAtivos = (contratoSelecionado.dependentes || []).filter(d => 
            d.nomeSituacao === "ATIVO" && 
            d.grauParentescoNome !== "TITULAR" && // Evita contar o titular duas vezes
            d.codigoDependente
        ).length;
        
        // 2. Vidas Atuais = Titular (1) + Dependentes Reais
        const vidasAtuais = 1 + dependentesReaisAtivos;
        
        // 3. Total Final
        const totalFinal = vidasAtuais + quantidadeNovos;

        console.log("--- AJUSTE DE CÁLCULO ---");
        console.log("Dependentes (excluindo titular):", dependentesReaisAtivos);
        console.log("Total de Vidas (Titular + Dep. Ativos):", vidasAtuais);
        console.log("Vidas com as novas inclusões:", totalFinal);

        let valorString = dadosPlanoLogado.value;

        if (dadosPlanoLogado.familyTable) {
            const ft = dadosPlanoLogado.familyTable;
            if (totalFinal === 2) valorString = ft.value3 || valorString;
            else if (totalFinal === 3) valorString = ft.value4 || valorString;
            else if (totalFinal >= 4) valorString = ft.value4 || valorString;
        }

        return parseFloat(valorString.replace(',', '.'));
    }

    /**
     * 
     * @param {*} contrato 
     */
    selecionarContrato(contrato) {
        // 1. Define o contrato no estado

        this.setState({ contratoSelecionado: contrato,
            dependentesParaIncluir: []
         });

        // 2. Tenta pegar o código do plano do primeiro dependente (como você faz no HTML)
        if (contrato.dependentes && contrato.dependentes[0]) {
            const codPlano = contrato.dependentes[0].codigoPlano;
            // 3. Chama o método de buscar dados (o que estava sem uso)
            this.buscarDadosDoPlano(codPlano);
        }

        // 🔹 Verifica se a empresa é pública
        const idEmpresa = contrato.codigoEmpresa; // ajuste se o nome for outro
        this.verificarEmpresaPublica(idEmpresa);

    } 
    /**
     * Extrair contato do RF
     * @param {*} contrato 
     * @returns 
     */  
    extrairContatosResponsavel(contrato) {
        let email = '';
        let celular = '';

        if (contrato && contrato.contatos) {
            contrato.contatos.forEach(function(contato) {
                if (contato.tipo === 'E-mail') {
                    email = contato.descricaoContato;
                }

                if (contato.tipo === 'Celular' || contato.tipo === 'MOBILE') {
                    celular = contato.descricaoContato;
                }
            });
        }

        return { email, celular };
    }     
handleInputChange(name, event) {
    var value = event.target.value;

    // Clona novoDep (ES5)
    var novoDep = Object.assign({}, this.state.novoDep);
    novoDep[name] = value;

    // Clona errosCampos (ES5)
    var errosCampos = Object.assign({}, this.state.errosCampos);

    // Remove o erro apenas do campo editado
    if (errosCampos[name]) {
        delete errosCampos[name];
    }

    // Se mudou o CPF → muda o contexto
    if (name === 'cpf') {
        this.setState({
            novoDep: novoDep,
            errosCampos: {},
            mensagemErro: null
        });
        return;
    }

    this.setState({
        novoDep: novoDep,
        errosCampos: errosCampos
    });
}
  
    /**
     * Calcula idade do dependente
     * @param {*} dataNascimento 
     * @returns 
     */
    calcularIdade(dataNascimento) {
        // Assume que a data vem no formato DD/MM/AAAA por causa da máscara
        var partesData = dataNascimento.split("/");
        if (partesData.length !== 3) return 0;

        var dataNasc = new Date(partesData[2], partesData[1] - 1, partesData[0]);
        var hoje = new Date();
        var idade = hoje.getFullYear() - dataNasc.getFullYear();
        var m = hoje.getMonth() - dataNasc.getMonth();

        if (m < 0 || (m === 0 && hoje.getDate() < dataNasc.getDate())) {
            idade--;
        }
        return idade;
    }  
    /**
     * Limpa os dados do formulário
     */
    resetFormularioDependente () {
        this.setState({
            modalAberto: true,          // já abre o modal
            mensagemErro: '',
            cpfValidado: '',
            carregandoDados: false,
            novoDep: {
                cpf: '',
                nomeDependente: '',
                dataNascimento: '',
                sexo: '',
                nomeMae: '',
                parentesco: '',
                celular: '',
                estadoCivil: '',
                cartaoSus: '',
                isReadOnly: false
            }
        });
        this.setState({
            errosCampos: {},
            mensagemErro: null,
            carregandoDados: false
        });        
    }
    /**
     * Finaliza Inclusões
     * @returns 
     */
    confirmarInclusoes() {
        const { contratoSelecionado, dependentesParaIncluir } = this.state;

        if (!contratoSelecionado || dependentesParaIncluir.length === 0) {
            alert('Nenhum dependente para inclusão.');
            return;
        }

        // trava UI
        this.setState({ isSending: true });

        const payload = this.montarPayloadInclusao();
        console.dir(payload)
        axios.post(
            urlBase.loopBack + 'Inclusions/saveProposal',
            payload
        )
        .then(() => {
            // limpa fila e formulário
            this.setState({
                dependentesParaIncluir: [],
                isSending: false,
                sucessoAberto: true
            });

            // opcional: recarregar contrato / voltar tela
            // this.handleSearch();
        })
        .catch((error) => {
            console.error(error);
            alert('Erro ao realizar inclusões. Verifique e tente novamente.');
            this.setState({ isSending: false });
        });
    }
    /**
     * Prepara dados para inclusão
     * @returns 
     */
    montarPayloadInclusao() {
        const { contratoSelecionado, dependentesParaIncluir } = this.state;
        const contatos = this.extrairContatosResponsavel(contratoSelecionado);
        const valorTotal = this.calcularValorInclusoes();
        const dependentes = dependentesParaIncluir.map(dep => ({
            sendS4E : false,
            type : 10,
            firstName: this.toUpperSafe(dep.nomeDependente),
            dateOfBirth :  this.formatarDataParaISO(dep.dataNascimento),
            cpf: dep.cpf || null,
            gender : dep.sexo,
            planId : contratoSelecionado.dependentes[0].codigoPlano,
            planValue : this.formatarValorParaBR(dep.valorPlano), 
            motherName: this.toUpperSafe(dep.nomeMae),
            maritalStatus :dep.estadoCivil,
            parentage: dep.parentesco,
            phone : dep.celular || null,
            celular: dep.celular || null,
            susNumber: dep.cartaoSus || null,
            rcaId: 8,
            lackService: 1,
            proposalNumber: ""

        }))

        return {
            dateSignatureContract :'',
            cpfHolder: contratoSelecionado.cpf,
            holder: this.toUpperSafe(contratoSelecionado.nome),
            holderId: contratoSelecionado.codigo,
            emailHolder: contatos.email,
            celularHolder: contatos.celular,
            planName: contratoSelecionado.dependentes[0].nomePlano,
            qtyNewDependents: dependentesParaIncluir.length.toString(),
            confirmationType: 'EMAIL',
            salesmanId: localStorage.getItem('dental_u'),
            userId: localStorage.getItem('dental_u'),
            salesmanCodeS4: this.state.salesmanCodeS4,
            brokerId: this.state.brokerId, 
            dependents: dependentes,
            planId: contratoSelecionado.dependentes[0].codigoPlano,
            observation:"",
            confirmation:  false,
            proposalNumber:"",
            totalValue: this.formatarValorParaBR(valorTotal),
            planPJ : false, // futuramente tratar aqui para pegar o tipo de plano
            empresaPublica : this.state.IsEmpresaPublica,
            dateFirstPayment: "",
            imagesDocs: {                
                doc1: "",
                doc2: "",                
            }
        }  

    }    
    /**
     * Calcula o valor total das inclusões
     * @returns 
     */
    calcularValorInclusoes() {
        return this.state.dependentesParaIncluir.reduce(
            (total, dep) => total + (dep.valorPlano || 0),
            0
        );
    }
    /**
     * Transformar em caixa alta
     * @param {*} valor 
     * @returns 
     */
    toUpperSafe(valor) {
        if (!valor || typeof valor !== 'string') return valor;
        return valor.toUpperCase().trim();
    }

    /**
     * Verifica se a empresa é pública
     * @param {*} idEmpresa 
     */
    verificarEmpresaPublica(idEmpresa) {
        if (!idEmpresa) {
            this.setState({ IsEmpresaPublica: false });
            return;
        }

        const dados = {
            codigo: idEmpresa.toString()
        };

        const termoPublico = 'SERVIDOR PUBLICO';

        axios
            .post(urlBase.loopBack + 'APIS4s/BuscarEmpresa', dados)
            .then((response) => {
                let isPublica = false;

                if (response.data && response.data.length > 0) {
                    const tipoEmpresa = (response.data[0].DescTipoEmpresa || '').toUpperCase();
                    isPublica = tipoEmpresa.includes(termoPublico);
                }

                this.setState({ IsEmpresaPublica: isPublica });
            })
            .catch((erro) => {
                console.error('Erro ao buscar tipo de empresa:', erro);
                this.setState({ IsEmpresaPublica: false });
            });
    }   
    /**
     * Formatar data para AAAA-MM-DD
     * @param {*} dataBR 
     * @returns 
     */
    formatarDataParaISO(dataBR) {
        if (!dataBR) return null;

        const partes = dataBR.split('/');
        if (partes.length !== 3) return null;

        const [dia, mes, ano] = partes;

        return `${ano}-${mes}-${dia}`;
    }
    /**
     * Formata data para DD/MM/AAA
     * @param {*} dataUS 
     * @returns 
     */
    formatarDataUSParaBR(dataUS) {
        if (!dataUS || typeof dataUS !== 'string') return null;

        // separa data e hora
        const [data] = dataUS.split(' ');
        if (!data) return null;

        // MM/DD/AAAA
        const partes = data.split('/');
        if (partes.length !== 3) return null;

        const [mes, dia, ano] = partes;

        return `${dia}/${mes}/${ano}`;
    }    
    /**
     * Formatar valor
     * @param {*} valor 
     * @returns 
     */
    formatarValorParaBR(valor) {
        if (valor === null || valor === undefined || isNaN(valor)) {
            return "0,00";
        }

        return Number(valor)
            .toFixed(2)        // garante 2 casas decimais
            .replace('.', ','); // troca ponto por vírgula
    }
    /**
     * Validação dos campos
     * @returns 
     */
    validarCamposObrigatorios () {
        const { novoDep } = this.state;
        let erros = {};

        if (!novoDep.nomeDependente || novoDep.nomeDependente.trim() === "") {
            erros.nomeDependente = "Campo obrigatório";
        }

        if (!novoDep.dataNascimento || novoDep.dataNascimento.trim() === "") {
            erros.dataNascimento = "Campo obrigatório";
        }

        if (!novoDep.nomeMae || novoDep.nomeMae.trim() === "") {
            erros.nomeMae = "Campo obrigatório";
        }

        if (!novoDep.sexo) {
            erros.sexo = "Campo obrigatório";
        }

        if (!novoDep.parentesco) {
            erros.parentesco = "Campo obrigatório";
        }

        if (!novoDep.estadoCivil) {
            erros.estadoCivil = "Campo obrigatório";
        }

        if (!novoDep.celular || novoDep.celular.trim() === "") {
            erros.celular = "Campo obrigatório";
        }

        // ⚠ Cartão SUS propositalmente NÃO entra aqui

        this.setState({ errosCampos: erros });

        // Retorna true se NÃO houver erros
        return Object.keys(erros).length === 0;
    }
    /**
     * Mostrar mensagem de erro nos campos
     * @param {*} campo 
     * @returns 
     */
    renderErroCampo  (campo) {
        return this.state.errosCampos[campo] ? (
            <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '2px' }}>
                {this.state.errosCampos[campo]}
            </div>
        ) : null;
    }

    /* FIM DO NOVO */
    render() {
        var listaContratos = this.state.listaContratos;
        var selecionado = this.state.contratoSelecionado;
        
        var estilos = {
            card: { border: '1px solid #ddd', borderRadius: '8px', marginBottom: '20px', padding: '15px', backgroundColor: '#fff' },
            cardSelecao: { border: '1px solid #ddd', borderRadius: '8px', marginBottom: '10px', padding: '15px', backgroundColor: '#fff', cursor: 'pointer', borderLeft: '5px solid #007bff' },
            header: { display: 'flex', justifyContent: 'space-between', borderBottom: '2px solid #007bff', paddingBottom: '8px', marginBottom: '12px' },
            secaoDependentes: { marginTop: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '6px' },
            tabela: { width: '100%', borderCollapse: 'collapse', fontSize: '13px' },
            th: { textAlign: 'left', borderBottom: '1px solid #ccc', padding: '5px' },
            td: { padding: '5px', borderBottom: '1px dotted #eee' },
            badgeAtivo: { color: '#28a745', fontWeight: 'bold' }
        };

        return (
            <div id="resume_content">
                <style>{`
                    #resume_content a { color: inherit; }
                    #resume_content a:hover { text-decoration: none; }
                    .card-hover:hover { background-color: #f1f7ff !important; }
                `}</style>

                <div style={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold', color: '#334155', marginBottom: '25px' }}>
                    INCLUSÃO DE DEPENDENTES
                </div>
                {this.state.snackbar && (
                <Snackbar
                    open={this.state.snackbar.open}
                    message={this.state.snackbar.msg}
                    autoHideDuration={4000}
                    onRequestClose={this.snackbarRequestClose.bind(this)}
                />
                )}

                <Row>
                    <Col xs="12">
                        <p onClick={this.goBack.bind(this)} style={{ cursor: 'pointer' }}> <FaStepBackward /> Voltar</p>
                    </Col>
                </Row>

                <div>
                    <label>Consultar Associado:</label>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                        <input 
                            type="text" 
                            placeholder="000.000.000-00"
                            className="form-control"
                            value={this.state.cpfInput}
                            onChange={(e) => this.setState({ cpfInput: e.target.value })}
                        />
                        <button 
                            onClick={this.handleSearch.bind(this)}
                            style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
                            
                        >
                            Pesquisar
                        </button>
                    </div>

                    {/* LOGICA DE TELAS */}
                    {selecionado ? (
                        /* TELA 2: DETALHAMENTO DO CONTRATO SELECIONADO */
                        <div className="detalhe-selecionado">
                            <button 
                                onClick={() => this.setState({ contratoSelecionado: null, dependentesParaIncluir: [] })}
                                style={{ 
                                ...Styles.buttonCancel, 
                                backgroundColor: Colors.textLight, // Usando cinza para cancelar
                                textTransform: 'none' 
                                }}      >
                                ← Voltar aos contratos
                            </button>
                            <br/>
                            <div style={estilos.card}>
                                <div style={estilos.header}>
                                    <span><strong>CÓDIGO CONTRATO:</strong> {selecionado.codigo}</span>
                                    <span><strong>EMPRESA:</strong> {selecionado.nomeFantasiaDaEmpresa}</span>
                                </div>

                                <div style={{ marginBottom: '10px' }}>
                                    <p style={{ margin: '5px 0' }}><strong>Responsável Financeiro:</strong> {selecionado.nome}</p>
                                    <p style={{ margin: '5px 0' }}><strong>Plano:</strong> {selecionado.dependentes && selecionado.dependentes[0] ? selecionado.dependentes[0].codigoPlano + " - " + selecionado.dependentes[0].nomePlano : 'N/A'}</p>
                                    {/*}
                                    {this.state.dadosPlanoLogado && (
                                            <p style={{ margin: '5px 0', color: '#28a745', fontWeight: 'bold' }}>
                                                <strong>Valor :</strong> R$ {selecionado.dependentes && selecionado.dependentes[0] ? selecionado.dependentes[0].valorPlano  : '0,00'}
                                            </p>
                                    )}  
                                            */}    
                                    <p style={{ margin: '5px 0' }}><strong>Data de Adesão:</strong> {this.formatarDataUSParaBR(selecionado.dataDeAssinaturaDoContrato)}</p>                          
                                    <div style={{ marginTop: '8px', fontSize: '13px', color: '#444' }}>
                                        {selecionado.contatos && selecionado.contatos.map(function(contato, idx) {
                                            return (
                                                <div key={idx} style={{ display: 'inline-block', marginRight: '15px' }}>
                                                    <strong>{contato.tipo}:</strong> {contato.descricaoContato}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                <div style={estilos.secaoDependentes}>
                                    <h4 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>Dependentes Ativos</h4>
                                    

                                    <div className="responsive-table-wrapper">
                                        <table
                                            className="responsive-table"
                                            style={{
                                                width: '100%',
                                                marginTop: '10px',
                                                fontSize: '12px',
                                                borderCollapse: 'collapse'
                                            }}
                                        >

                                        <thead>
                                            <tr>
                                                <th style={estilos.th}>Nome</th>
                                                <th style={estilos.th}>Parentesco</th>
                                                <th style={estilos.th}>CPF</th>
                                                <th style={estilos.th}>Status</th>
                                                <th style={estilos.th}>Valor Plano</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selecionado.dependentes.filter(d => d.nomeSituacao === "ATIVO").map(function(dep) {
                                                var estiloStatus = Object.assign({}, estilos.td, estilos.badgeAtivo);
                                                return (
                                                    <tr key={dep.codigoDependente}>
                                                        <td style={estilos.td}>{dep.nomeDependente}</td>
                                                        <td style={estilos.td}>{dep.grauParentescoNome}</td>
                                                        <td style={estilos.td}>{dep.numeroCpfDependente || 'N/I'}</td>
                                                        <td style={estiloStatus}>{dep.nomeSituacao}</td>
                                                        <td style={estilos.td}>{dep.valorPlano}</td>

                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                            </div>

                            {/* LISTA DE NOVOS DEPENDENTES (FILA) */}
                            <div style={{ marginTop: '20px', padding: '15px', border: '1px dashed #28a745', borderRadius: '8px', backgroundColor: '#fafffa' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h5 style={{ color: '#28a745', margin: 0 }}>Dependentes para Inclusão</h5>
                                    <button 
                                        onClick={() => this.resetFormularioDependente()}
                                        style={{ backgroundColor: '#28a745', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer' }}
                                    >
                                        + Incluir
                                    </button>
                                </div>

                                {this.state.dependentesParaIncluir.length > 0 ? (

                                    <div className="responsive-table-wrapper">
                                        <table
                                            className="responsive-table"
                                            style={{
                                                width: '100%',
                                                marginTop: '10px',
                                                fontSize: '12px',
                                                borderCollapse: 'collapse'
                                            }}
                                        >

                                        <thead>
                                            <tr style={{ textAlign: 'left', borderBottom: '1px solid #28a745' }}>
                                                <th style={{ padding: '5px' }}>Nome</th>
                                                <th style={{ padding: '5px' }}>CPF</th>
                                                <th style={{ padding: '5px' }}>Parentesco</th>
                                                <th>Valor do Plano</th>                                            
                                                <th style={{ padding: '5px' }}>Ação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.dependentesParaIncluir.map(function(dep, index) {
                                                return (
                                                    <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                                                        <td style={{ padding: '5px' }}>{dep.nomeDependente}</td>
                                                        <td style={{ padding: '5px' }}>{dep.cpf}</td>
                                                        <td style={{ padding: '5px' }}>{dep.parentesco}</td>
                                                        <td>{dep.valorPlano.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>                                                    
                                                        <td style={{ padding: '5px' }}>
                                                            <span 
                                                                style={{ color: 'red', cursor: 'pointer' }} 
                                                                onClick={function() {
                                                                    // 1. Criamos uma cópia da lista atual
                                                                    var lista = [...this.state.dependentesParaIncluir];
                                                                    
                                                                    // 2. Removemos o item pelo index
                                                                    lista.splice(index, 1);

                                                                    // 3. Calculamos o novo valor unitário para a quantidade que sobrou
                                                                    // Chamamos a função passando o novo tamanho da lista
                                                                    var novoValorUnitario = this.calcularPrecoPorVidas(lista.length);

                                                                    // 4. Atualizamos o preço de todos os dependentes restantes na lista
                                                                    var listaRecalculada = lista.map(function(dep) {
                                                                        return Object.assign({}, dep, { valorPlano: novoValorUnitario });
                                                                    });

                                                                    // 5. Atualizamos o estado com a nova lista e valores corrigidos
                                                                    this.setState({ dependentesParaIncluir: listaRecalculada });
                                                                    
                                                                }.bind(this)}
                                                            >
                                                                Remover
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            }.bind(this))}
                                        </tbody>
                                    </table>
                                </div>
                                ) : (
                                    <p style={{ fontSize: '12px', color: '#888', marginTop: '10px' }}>Nenhum dependente aguardando inclusão.</p>
                                )}
                                <br/>
                                {this.state.dependentesParaIncluir.length > 0 && (
                                    <button
                                        onClick={() => this.setState({ confirmacaoAberta: true })}
                                        disabled={this.state.isSending}
                                        style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}

                                    >
                                        Finalizar Inclusões
                                    </button>


                                )}
                            </div>
                            <div style={{ textAlign: 'right', fontWeight: 'bold', marginTop: '10px' }}>
                                Total das Inclusões: {
                                    this.state.dependentesParaIncluir
                                        .reduce((acc, dep) => acc + (dep.valorPlano || 0), 0)
                                        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                                }
                            </div>                        
                        </div> /* FECHA detalhe-selecionado */
                    ) : (
                        /* TELA 1: LISTA PARA SELEÇÃO */
                        <div className="lista-selecao">
                            {listaContratos && listaContratos.length > 0 && (
                                <h4 style={{ marginBottom: '15px' }}>Contratos encontrados para este CPF:</h4>
                            )}
                            {listaContratos && listaContratos.map(function(contrato) {
                                return (
                                    <div 
                                        key={contrato.codigo} 
                                        className="card-hover"
                                        style={estilos.cardSelecao}
                                        onClick={() => this.selecionarContrato(contrato)}
                                    >
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div>
                                                <strong>{contrato.nomeFantasiaDaEmpresa}</strong>
                                                <div style={{ fontSize: '12px', color: '#666' }}>Contrato: {contrato.codigo}</div>
                                                <div style={{ fontSize: '12px', color: '#666' }}>Plano: {contrato.dependentes[0].nomePlano }</div>
                                            </div>
                                            <div style={{ color: '#007bff', fontWeight: 'bold' }}>Ver detalhes →</div>
                                        </div>
                                    </div>
                                );
                            }.bind(this))}
                        </div> /* FECHA lista-selecao */
                    )}
                </div> {/* FECHA a div que envolve as telas */}

                {/* MODAL DE INCLUSÃO */}
                <Dialog
                    title="Inclusão de Novo Dependente"
                    modal={true}
                    open={this.state.modalAberto}
                    autoScrollBodyContent={true}
                    contentStyle={{ width: '80%', maxWidth: 'none' }}
                >
                    <div style={{ padding: '20px' }}>
                        {/* BLOCO 1: VERIFICAÇÃO */}
                        <Row>
                            <Col>
                                {/* Sinalizador de Carregamento */}
                                {this.state.carregandoDados && (
                                    <div style={{ color: '#007bff', marginTop: '5px', fontWeight: 'bold' }}>
                                        <i className="fa fa-refresh fa-spin"></i> Buscando dados, aguarde...
                                    </div>
                                )}

                                {/* Mensagem de Erro ou Validação */}
                                {this.state.mensagemErro && !this.state.carregandoDados && (
                                    <div style={{ 
                                        color: '#721c24', 
                                        backgroundColor: '#f8d7da', 
                                        borderColor: '#f5c6cb',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        marginTop: '5px',
                                        fontSize: '13px',
                                        fontWeight: 'bold',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <i className="fa fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                                        {this.state.mensagemErro}
                                    </div>
                                )}
                            </Col>
                        </Row>     
                        <hr />

                        <Row>
                            <Col xs="12" md="6">
                                <label>CPF para Verificação:</label>
                                <div style={{ display: 'flex', gap: '5px' }}>
                                    <InputMask 
                                        mask="999.999.999-99" 
                                        value={this.state.novoDep.cpf || ''} 
                                        onChange={(e) => this.handleInputChange('cpf', e)}
                                        onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault(); // Evita que o formulário recarregue a página
                                                    this.verificarEApurarCPF();
                                                }
                                            }}
                                            // Gatilho 2: Quando o cursor sair do campo
                                            /*
                                            onBlur={() => {
                                                // Só dispara se o CPF estiver preenchido (para não dar erro ao clicar fora com campo vazio)
                                                const cpfLimpo = (this.state.novoDep.cpf || "").replace(/[^\d]+/g, '');
                                                if (cpfLimpo.length === 11) {
                                                    this.verificarEApurarCPF();
                                                }
                                            }}   
                                            */                     
                                    >
                                        {(inputProps) => (
                                            <input 
                                                {...inputProps}
                                                type="text" 
                                                className="form-control" 
                                                placeholder="000.000.000-00"
                                            />
                                        )}
                                    </InputMask>                    

                                    <button className="btn btn-primary" onClick={this.verificarEApurarCPF.bind(this)}>Verificar</button>
                                
                                </div>
                            </Col>
                        </Row>

                        <hr />

                        {/* BLOCO 2: DADOS DA API (AUTO-PREENCHIDOS) */}
                        <Row>
                            <Col xs="12" md="8">
                                <label>Nome do Dependente:</label>
                                <input 
                                    type="text"
                                    name="nomeDependente"
                                    className="form-control"
                                    value={this.state.novoDep.nomeDependente || ''}
                                    onChange={(e) => this.handleInputChange('nomeDependente', e)}
                                    // Só fica bloqueado se isReadOnly for true E o campo não estiver vazio
                                    readOnly={this.state.novoDep.isReadOnly && this.state.novoDep.nomeDependente !== ''}
                                    style={this.state.novoDep.isReadOnly ? { backgroundColor: '#f0f0f0' } : { border: '1px solid #007bff' }}
                                /> 
                                {this.renderErroCampo('nomeDependente')}             
                            </Col>
                            <Col xs="12" md="4">
                                <label>Data de Nascimento:</label>
                                {/* Data de Nascimento */}
                                <InputMask 
                                    mask="99/99/9999" 
                                    maskChar="_"
                                    className="form-control"
                                    placeholder="DD/MM/AAAA"
                                    value={this.state.novoDep.dataNascimento || ''} 
                                    onChange={(e) => this.handleInputChange('dataNascimento', e)}
                                    readOnly={this.state.novoDep.isReadOnly && this.state.novoDep.dataNascimento !== ''}
                                    style={this.state.novoDep.isReadOnly ? { backgroundColor: '#f0f0f0' } : { border: '1px solid #007bff' }}
                                />
                                {this.renderErroCampo('dataNascimento')}
                            </Col>
                        </Row>

                        <Row style={{ marginTop: '10px' }}>
                            <Col xs="12" md="8">
                                <label>Nome da Mãe:</label>
                                {/* Nome da Mãe */}
                                <input 
                                    type="text" 
                                    name="nomeMae"
                                    className="form-control"
                                    value={this.state.novoDep.nomeMae || ''}
                                    onChange={(e) => this.handleInputChange('nomeMae', e)}
                                    //readOnly={this.state.novoDep.isReadOnly && this.state.novoDep.nomeMae !== ''}
                                    style={this.state.novoDep.isReadOnly ? { backgroundColor: '#f0f0f0' } : { border: '1px solid #007bff' }}
                                />
                                {this.renderErroCampo('nomeMae')}

                            </Col>
                            <Col xs="12" md="4">
                                <label>Sexo:</label>
                                {/* Sexo (SelectField) */}
                                <SelectField
                                    value={this.state.novoDep.sexo || ''}
                                    onChange={(event, index, value) => {
                                        var d = Object.assign({}, this.state.novoDep, { sexo: value });
                                        this.setState({ novoDep: d });
                                    }}
                                    // Desabilita apenas se veio da base
                                    disabled={this.state.novoDep.isReadOnly && this.state.novoDep.sexo !== ''}
                                    fullWidth={true}
                                    style={{ height: '38px', backgroundColor: this.state.novoDep.isReadOnly ? '#f0f0f0' : '#fff' }}
                                    underlineStyle={{ display: 'none' }}
                                    className="input_style form-control"
                                >                                   
                                    <MenuItem value={""} primaryText="Selecione" />
                                    <MenuItem value={"1"} primaryText="MASCULINO" />
                                    <MenuItem value={"0"} primaryText="FEMININO" />
                                </SelectField>
                                {this.renderErroCampo('sexo')}

                            </Col>
                        </Row>

                        {/* BLOCO 3: INFORMAÇÕES COMPLEMENTARES (MANUAIS) */}
                        <h5 style={{ color: '#007bff', borderBottom: '1px solid #eee', paddingBottom: '5px', marginTop: '30px' }}>
                            Informações Complementares
                        </h5>

                        <Row style={{ marginTop: '10px' }}>
                            <Col xs="12" md="3">
                                <label>Parentesco:</label>
                                <SelectField
                                    value={this.state.novoDep.parentesco || ''}
                                    onChange={(event, index, value) => {
                                        var d = Object.assign({}, this.state.novoDep, { parentesco: value });
                                        this.setState({ novoDep: d });
                                    }}
                                    fullWidth={true}
                                    underlineStyle={{ display: 'none' }}
                                    className="input_style form-control"
                                    style={{ height: '38px', lineHeight: '24px' }}
                                >
                                    <MenuItem value={""} primaryText="Selecione" />
                                    <MenuItem value={"CONJUGE"} primaryText="CÔNJUGE" />
                                    <MenuItem value={"FILHO"} primaryText="FILHO(A)" />
                                    <MenuItem value={"PAI_MAE"} primaryText="PAI/MÃE" />
                                    <MenuItem value={"OUTROS"} primaryText="OUTROS" />
                                </SelectField>
                                {this.renderErroCampo('parentesco')}
                            </Col>

                            <Col xs="12" md="3">
                                <label>Estado Civil:</label>
                                <SelectField
                                    value={this.state.novoDep.estadoCivil || ''}
                                    onChange={(event, index, value) => {
                                        var d = Object.assign({}, this.state.novoDep, { estadoCivil: value });
                                        this.setState({ novoDep: d });
                                    }}
                                    fullWidth={true}
                                    underlineStyle={{ display: 'none' }}
                                    className="input_style form-control"
                                    style={{ height: '38px', lineHeight: '24px' }}
                                >
                                    <MenuItem value={""} primaryText="Selecione" />
                                    <MenuItem value={"SOLTEIRO"} primaryText="SOLTEIRO" />
                                    <MenuItem value={"CASADO"} primaryText="CASADO" />
                                    <MenuItem value={"DIVORCIADO"} primaryText="DIVORCIADO" />
                                    <MenuItem value={"SEPARADO"} primaryText="SEPARADO" />
                                    <MenuItem value={"VIUVO"} primaryText="VIÚVO" />
                                    <MenuItem value={"RELAÇÃO ESTÁVEL"} primaryText="UNIÃO ESTÁVEL" />
                                </SelectField>
                                {this.renderErroCampo('estadoCivil')}

                            </Col>

                            <Col xs="12" md="3">
                                <label>Celular:</label>

                                <InputMask 
                                        mask="(99) 99999-9999" 
                                        maskChar="_"
                                        className="form-control"
                                        placeholder="(00) 00000-0000"
                                        value={this.state.novoDep.celular || ''}
                                        onChange={(e) => {
                                            var d = Object.assign({}, this.state.novoDep, { celular: e.target.value });
                                            this.setState({ novoDep: d });
                                        }}
                                />    
                                {this.renderErroCampo('celular')}
            
                            </Col>

                            <Col xs="12" md="3">
                                <label>Cartão SUS:</label>
                                <input 
                                    type="text" 
                                    className="form-control"
                                    placeholder="000 0000 0000 0000"
                                    value={this.state.novoDep.cartaoSus || ''}
                                    onChange={(e) => {
                                        var d = Object.assign({}, this.state.novoDep, { cartaoSus: e.target.value });
                                        this.setState({ novoDep: d });
                                    }}
                                />
                            </Col>
                        </Row>

                        {/* RODAPÉ COM BOTÕES */}
                        <div style={{ textAlign: 'right', marginTop: '30px' }}>
                            <button 
                                className="btn btn-default" 
                                onClick={() => this.setState({ modalAberto: false })} 
                                style={{ marginRight: '10px' }}
                            >
                                Cancelar
                            </button>
                            <button 
                                className="btn btn-success"
                                style={{ padding: '10px 20px' }}
                                onClick={() => this.adicionarDependenteAFila()}
                            >
                                Adicionar à Lista
                            </button>
                        </div>
                    </div>
                </Dialog>
                    {/* MODAL DE CONFIRMAÇÃO */}
                    <Dialog
                        title="Confirmar Inclusões"
                        modal={true}
                        open={this.state.confirmacaoAberta}
                        actions={[
                            <button
                                className="btn btn-default"
                                onClick={() => this.setState({ confirmacaoAberta: false })}
                            >
                                Cancelar
                            </button>,
                            <button
                                className="btn btn-success"
                                onClick={() => {
                                    this.setState({ confirmacaoAberta: false }, () => {
                                        this.confirmarInclusoes();
                                    });
                                }}
                            >
                                Confirmar e Enviar
                            </button>
                        ]}
                    >
                        <div style={{ fontSize: '14px' }}>
                            <p>
                                Você está prestes a incluir <strong>
                                    {this.state.dependentesParaIncluir.length}
                                </strong> dependente(s).
                            </p>

                            <p>
                                <strong>Valor total das inclusões:</strong><br/>
                                {this.calcularValorInclusoes().toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                })}
                            </p>

                            <p style={{ marginTop: '15px', color: '#856404' }}>
                                Deseja realmente prosseguir com a inclusão?
                            </p>
                        </div>
                    </Dialog>    
                    {/* MODAL DE SUCESSO */}
                    <Dialog
                        title="Inclusão realizada com sucesso"
                        modal={true}
                        open={this.state.sucessoAberto}
                        actions={[
                            <button
                                className="btn btn-default"
                                onClick={() => {
                                    this.setState({
                                        sucessoAberto: false,
                                        contratoSelecionado: null,
                                        dependentesParaIncluir: []
                                    });
                                }}
                            >
                                Permanecer na inclusão
                            </button>,
                            <button
                                className="btn btn-success"
                                onClick={() => {
                                    this.setState({ sucessoAberto: false }, () => {
                                        browserHistory.push(
                                            "/panel/lista-de-inclusoes?search=pendente"
                                        );
                                    });
                                }}
                            >
                                Ir para inclusões pendentes
                            </button>
                        ]}
                    >
                        <div style={{ fontSize: '14px' }}>
                            <p>
                                As inclusões foram realizadas com sucesso.
                            </p>

                            <p>
                                Você pode continuar realizando novas inclusões
                                ou acompanhar as inclusões pendentes para confirmação.
                            </p>
                        </div>
                    </Dialog>                            
            </div> /* FECHA resume_content (RAIZ DO RETURN) */
        );
    }

}


export default Inclusao;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/Inclusao/Page.js
 **/